import { NgModule } from '@angular/core';
import { BASE_STORE_WITH_SHOPS_NORMALIZER, OccBaseStoreWithShopsNormalizer } from './converters';
import { CityStoreModule } from './store/city-store.module';

@NgModule({
  imports: [CityStoreModule],
  providers: [
    {
      provide: BASE_STORE_WITH_SHOPS_NORMALIZER,
      useExisting: OccBaseStoreWithShopsNormalizer,
      multi: true,
    },
  ],
})
export class CityDataAccessModule {}
